import Info from "../../../../docs/components/Info";
import * as React from 'react';
export default {
  Info,
  React
};